export default function getSecondary(id) {
  switch(id) {
    case 'QkaQHG5U1yhPGQBa4bX3': return 'rgba(34,139,34,0.6)';
    case 'GH2CCtKRoiU0fkZq4pzZ': return 'rgba(34,139,34,0.6)';
    case 'z9VALcDLcbhMlfOSEnUV': return 'rgba(238, 130, 238, 0.6)';
    case 'pwaV5P3ATIYUxkl7WSAb': return 'rgba(0, 191, 255, 0.6)';
    case 'XgLPT7zlVTiOYZ4scAbR': return 'rgba(220, 20, 60, 0.6)';
    case '9DYY5U4yCzOXR3NDxV5N': return 'rgba(218, 165, 32, 0.6)';
    case 'Og7AHkKWFh8T8WlNj9Uk': return 'rgba(128, 0, 128, 0.6)';
    default: return 'transparent';
  }
}